var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" © All rights reserved. "),_c('strong',[_vm._v("Ciphra")]),_vm._v(" "+_vm._s(new Date().getFullYear())+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }